module.exports = __webpack_public_path__ + "img/Geschenketag.dceb1e77.svg";